<template>
  <!-- Search Area -->
  <el-row class="search-area">
    <el-col class="makeInline" :lg="16" :md="16" :sm="24">
          <el-input :placeholder="$locale('form.plsEnterYourName')" v-model="searchInput" class="searchMaxWidth">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-button class="egl-btn-yellow makeLeft" @click="searchAction(searchInput)"
          >{{ $locale("global.search") }}</el-button>
    </el-col>
    <el-col class="ta-r" :lg="8" :md="8" :sm="24">
      <el-button class="egl-btn-yellow right-align-btn" @click="createAction()"
        >{{ $locale("global.create") }}</el-button>
    </el-col>
  </el-row>
</template>
<style scoped>
.makeInline {
  white-space: nowrap;
}
.el-col {
  margin-bottom: 5px;
}
.searchMaxWidth {
  max-width: 350px;
  margin-right: 5px;
}
.makeLeft {
  margin-left: 5px;
}
</style>

<script>
export default {
  data() {
    return {
      searchInput: ""
    };
  },
  props: {
    createAction: {
      type: Function,
      default: () => {}
    },
    searchAction: {
      type: Function,
      default: () => {}
    },
  }
};
</script>
